"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var decomposePath_1 = __importDefault(require("./decomposePath"));
function getFullDeps(nodesDeps, path, deps) {
    var nodeDeps = nodesDeps[path];
    if (!deps) {
        deps = [];
    }
    var paths = Object.keys(nodesDeps);
    for (var j = 0; j < nodeDeps.length; j += 1) {
        var dep = nodeDeps[j];
        var reg = new RegExp("^" + dep);
        var parts = (0, decomposePath_1.default)(dep);
        //@ts-ignore
        parts.push(dep);
        var selected = false;
        // Add all dynamic nodes
        for (var k = 0; k < paths.length; k += 1) {
            var cur = paths[k];
            if (
            //@ts-ignore
            (parts.indexOf(cur) !== -1 || cur.match(reg) !== null) &&
                deps.indexOf(cur) === -1) {
                selected = true;
                deps.push(cur);
                getFullDeps(nodesDeps, cur, deps);
                var curParts = (0, decomposePath_1.default)(cur);
                // if the path is a child of the dep then
                // it is a static node containing a child dynamic
                // node
                if (curParts.length > parts.length) {
                    deps.push(dep);
                }
            }
        }
        // Add static nodes
        if (selected === false) {
            deps.push(dep);
        }
    }
    return deps;
}
exports.default = getFullDeps;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0RnVsbERlcHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm4vZ2V0RnVsbERlcHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxrRUFBNEM7QUFHNUMsU0FBUyxXQUFXLENBQUMsU0FBUyxFQUFFLElBQUksRUFBRSxJQUFJO0lBQ3hDLElBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUUvQixJQUFJLENBQUMsSUFBSSxFQUFFO1FBQ1QsSUFBSSxHQUFHLEVBQUUsQ0FBQztLQUNYO0lBRUQsSUFBSSxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUVuQyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsUUFBUSxDQUFDLE1BQU0sRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQzNDLElBQUksR0FBRyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN0QixJQUFJLEdBQUcsR0FBRyxJQUFJLE1BQU0sQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDLENBQUM7UUFDaEMsSUFBSSxLQUFLLEdBQUcsSUFBQSx1QkFBYSxFQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQy9CLFlBQVk7UUFDWixLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ2hCLElBQUksUUFBUSxHQUFHLEtBQUssQ0FBQztRQUVyQix3QkFBd0I7UUFDeEIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUN4QyxJQUFJLEdBQUcsR0FBRyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFFbkI7WUFDRSxZQUFZO1lBQ1osQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxJQUFJLEdBQUcsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLEtBQUssSUFBSSxDQUFDO2dCQUN0RCxJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUN4QjtnQkFDQSxRQUFRLEdBQUcsSUFBSSxDQUFDO2dCQUNoQixJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO2dCQUNmLFdBQVcsQ0FBQyxTQUFTLEVBQUUsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFDO2dCQUVsQyxJQUFJLFFBQVEsR0FBRyxJQUFBLHVCQUFhLEVBQUMsR0FBRyxDQUFDLENBQUM7Z0JBRWxDLHlDQUF5QztnQkFDekMsaURBQWlEO2dCQUNqRCxPQUFPO2dCQUNQLElBQUksUUFBUSxDQUFDLE1BQU0sR0FBRyxLQUFLLENBQUMsTUFBTSxFQUFFO29CQUNsQyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO2lCQUNoQjthQUNGO1NBQ0Y7UUFFRCxtQkFBbUI7UUFDbkIsSUFBSSxRQUFRLEtBQUssS0FBSyxFQUFFO1lBQ3RCLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7U0FDaEI7S0FDRjtJQUVELE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQztBQUVELGtCQUFlLFdBQVcsQ0FBQyJ9